import styled from 'styled-components';

const TitleMedium = styled.h4`
  margin-bottom: 4px;
  font-size: 14px;
  color: #173c51;
`;

export default TitleMedium;
